import getDateFormatter from './getDateFormatter';

const defaultOptions = { calendar: 'gregory', numberingSystem: 'latn' };

export default function formatDate(date, options, locale) {
    //TODO: remove -u-ca-gregory once Safari <=13 no longer supported. Passing calendar as an option only supported by >=14 Safari versions.
    return getDateFormatter(locale + '-u-ca-gregory', { ...defaultOptions, ...options }).format(date);
}
